<template>
	<component
		:is="tag"
		:title="title"
		data-toggle="tooltip"
		:data-bs-custom-class="bsCustomClass"
		:data-placement="placement"
	>
		<slot />
	</component>
</template>

<script setup>
import { nextTick, onMounted } from 'vue';

const props = defineProps({
	title: String,
	placement: {
		type: String,
		default: 'top',
	},
	tag: {
		type: String,
		default: 'div',
	},
	bsCustomClass: {
		type: String,
		default: 'tooltip-dark',
	},
});

onMounted(() => {
	nextTick(() => {
		$(function () {
			$('[data-toggle="tooltip"]').tooltip();
		});
	});
});
</script>

<style lang="scss" scoped></style>
